$(document).on("click",".js-wk_overlay_close",function (e){
    e.preventDefault();
    showLoader();
    $(".js-wk_overlay").removeClass("wk_overlay-open");
    $("body").removeClass("noscroll");
    $(".js-wk_overlay").trigger('scroll');
    $(".js-teilnehmer_form").get(0).reset();
    document.location = $(this).attr("href");
})

$(document).on("click",".js-wk_overlay_open",function (e){

    e.preventDefault();
    if($(this).data("max") == 1){
        formMsgBlockShow($(".js-teilnehmer_form").find(".js-form_warning"));
    }
    wkOpenOverlay($(this).data("id"))

})

if(typeof idOpenOverlay != "undefined" && idOpenOverlay != ""){
    wkOpenOverlay(idOpenOverlay);
}

function wkOpenOverlay(id){
    $(".js-wk_overlay").show();
    setTimeout(function (){
        $(".js-teilnehmer_form").find(".js-from_submit").data("id",id);
        $(".js-teilnehmer_form").get(0).reset();
        $(".js-wk_overlay").addClass("wk_overlay-open");

        $("body").addClass("noscroll");
        $(".js-wk_overlay").trigger('scroll');
        $('[name=salutation]').trigger('focus');
    },25)
}
